// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"_30a6e0f","betSlipOpen":"_1c2af95","title":"_273c7ce","content":"_83d6c39","count":"_3d7a13f"};